import { Component, PropSync } from 'vue-property-decorator';
import { FieldEventTypeEnums } from '@/enums/FieldEventTypeEnums';
import FieldComponent from '@/components/edit/field/Field';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { LoggerService } from '@/utils';

export interface IFieldComponentMethods {
    validateField(): boolean;
}

export interface IFieldEvent {
    type: FieldEventTypeEnums;
    value: any;
}

@Component
export default class FieldTableComponent extends FieldComponent implements IFieldComponentMethods {
    // tslint:disable-next-line: no-empty
    public async mounted() {}

    public getFilled(): boolean {
        let isFilled = false;
        switch (this.syncedField.type) {
            case FieldTypeEnum.TEXT:
            case FieldTypeEnum.TEXTAREA:
            case FieldTypeEnum.SEARCH:
                isFilled = this.text != null && this.text.length > 0;
                break;
            case FieldTypeEnum.AXSELECT:
            case FieldTypeEnum.MYMILL_SELECT:
            case FieldTypeEnum.MYMILL_SELECT:
            case FieldTypeEnum.SELECT:
            case FieldTypeEnum.UNIT:
                isFilled = this.selectValue != null;
                break;
            case FieldTypeEnum.DATE:
                isFilled = this.date != null && this.date.length > 0;
                break;
            case FieldTypeEnum.DATETIME:
                isFilled = this.datetime != null && this.datetime.length > 0;
                break;
            case FieldTypeEnum.NUMBER:
                isFilled = this.numberValueString != null && this.numberValueString.length > 0;
                break;
            default:
                break;
        }
        return isFilled;
    }
}
